import { TTgbNativedescGeneralContext } from '@cian/adfox-templates';
import React, { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import { TgbNativedescGeneral } from './TgbNativedescGeneral';
import { getTgbNativedescGeneralProps } from './internal/utils/getTgbNativedescGeneralProps';
import { IBannerEnrichments } from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/BannerEnrichments';
import {
  EDealType,
  EObjectType,
} from 'shared/repositories/ad-banner/entities/get_banner_enrichments_v1/GetBannerEnrichmentsV1Request';
import { selectJsonQuery } from 'shared/selectors/results/selectJsonQuery';
import { fetchGetNewbuildingsForSerpService } from 'shared/services/fetchGetNewbuildingsForSerpService';
import { useAdfoxContext } from 'shared/utils/AdfoxContext';
import { useApplicationContext } from 'shared/utils/applicationContext';

type TgbNativedescGeneralContainerProps = {
  context: TTgbNativedescGeneralContext;
};

export const TgbNativedescGeneralContainer: FC<TgbNativedescGeneralContainerProps> = props => {
  const { context } = props;

  const { newBuildingId, newBuildingIdIsUsed, objectId, objectType, dealType, useServerEnrichment } = context;

  const applicationContext = useApplicationContext();
  const { sizes } = useAdfoxContext();

  const [bannerEnrichments, setBannerEnrichments] = useState<IBannerEnrichments | undefined>();

  const jsonQuery = useSelector(selectJsonQuery);

  const newBuildingIdInt = newBuildingId ? parseInt(newBuildingId, 10) : null;
  const objectIdInt = objectId ? parseInt(objectId, 10) : newBuildingIdInt;

  /**
   * @description Только для значений newBuildingIdIsUsed === '1' и useServerEnrichment === '1' делаем запрос на бекенд для обогащения данных
   */
  const isEnrichmentFromBackendEnabled = newBuildingIdIsUsed === '1' || useServerEnrichment === '1';

  useEffect(() => {
    if (isEnrichmentFromBackendEnabled && objectIdInt && !bannerEnrichments) {
      fetchGetNewbuildingsForSerpService(applicationContext, {
        objectId: objectIdInt,
        dealType: dealType as EDealType,
        objectType: objectType as EObjectType,
      })
        .then(data => {
          setBannerEnrichments(data.enrichments);
        })
        .catch(() => {});
    }
    /**
     * @description Тут смотрим на изменение objectIdInt, изменение остальных данных не должно триггерить запрос
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectIdInt]);

  return (
    <TgbNativedescGeneral
      {...getTgbNativedescGeneralProps({
        jsonQuery,
        sizes,
        context,
        bannerEnrichments,
      })}
    />
  );
};
